import { classNamesFunction, Stack, Text } from '@fluentui/react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import React from 'react';
import { NotificationItemStatus } from '..';
dayjs.extend(duration);
dayjs.extend(localizedFormat);
var getClassNames = classNamesFunction();
export var NotificationHeaderBase = function (props) {
    var styles = props.styles, item = props.item, sender = props.sender, senderId = props.senderId, subject = props.subject, subjectId = props.subjectId, dateFormatter = props.dateFormatter, timeFormatter = props.timeFormatter, timeGroupLabels = props.timeGroupLabels;
    var classNames = getClassNames(styles, {
        isRead: item.status === NotificationItemStatus.READ
    });
    var getTimestamp = function () {
        var _a;
        var MDYYFormat = 'M/D/YY';
        var start = dayjs(dayjs().format(dateFormatter !== null && dateFormatter !== void 0 ? dateFormatter : MDYYFormat));
        var end = dayjs(item.timeDelivered.format(dateFormatter !== null && dateFormatter !== void 0 ? dateFormatter : MDYYFormat));
        var timeDiff = dayjs.duration(start.diff(end)).asDays();
        if (timeDiff === 0) {
            return item.timeDelivered.format(timeFormatter !== null && timeFormatter !== void 0 ? timeFormatter : 'LT');
        }
        else if (timeDiff === 1) {
            return (_a = timeGroupLabels === null || timeGroupLabels === void 0 ? void 0 : timeGroupLabels.yesterday) !== null && _a !== void 0 ? _a : 'Yesterday';
        }
        else {
            return item.timeDelivered.format(dateFormatter !== null && dateFormatter !== void 0 ? dateFormatter : MDYYFormat);
        }
    };
    return (React.createElement(Stack, { className: classNames.timestampRow, horizontal: true },
        React.createElement(Stack, { className: classNames.subjectContainer },
            sender.name && (React.createElement(Text, { id: senderId, className: classNames.senderName, nowrap: true }, sender.name)),
            React.createElement("h3", { id: subjectId, className: classNames.subjectText }, subject.header)),
        React.createElement(Text, { className: classNames.timeDelivered, nowrap: true },
            React.createElement("span", { className: classNames.timeHook }, getTimestamp()))));
};
//# sourceMappingURL=NotificationHeader.base.js.map